<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ofxLL6/tc-custom/9781451625271.jpg?1718106016457" alt="This image is the cover for the book In His Own Write"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In His Own Write
      </h1>
      <p class="bookDescription body article font2">
        <b>AN OMNIBUS EDITION OF JOHN LENNON’ S </b><b>WHIMSICAL POETRY, PROSE, AND DRAWINGS, </b><b>REISSUED IN CELEBRATION OF THE </b><b>70TH ANNIVERSARY OF HIS BIRTH. </b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Lennon, Yoko Ono
      </h2>
      
      <p class="authorDescription body article">Best known as singer-songwriter for the legendary Beatles, John Lennon was born in Liverpool, England. In 1969, Lennon married Yoko Ono and the two formed the Plastic Ono Band. Lennon was killed by a deranged fan outside his apartment building in New York on December 8, 1980.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cae3abc